import { render } from "./Stage.vue?vue&type=template&id=334101d3&scoped=true"
import script from "./Stage.vue?vue&type=script&lang=js"
export * from "./Stage.vue?vue&type=script&lang=js"

import "./Stage.vue?vue&type=style&index=0&id=334101d3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-334101d3"

export default script